import axios from 'axios'
const instance = axios.create({
    //  baseURL: 'https://web3.huagongyuan.com.cn/api',
    //  baseURL: 'http://localhost:5001',
    //  baseURL: 'http://192.168.0.110:5001',
     baseURL: 'https://linchang.sd-bank.cn/api',


    timeout: 5000,
    headers: { 'Content-Type': 'application/json' }
});

instance.interceptors.request.use(function (config) {
    config.headers.token = localStorage.getItem("token");
    return config;
}, function (error) {
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});

export default instance;